/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-06-19 11:03:44
 * @modify date 2023-06-19 11:03:44
 * @desc [description]
 */



import { Modal, View, StyleSheet, Pressable, Text } from "react-native";
import { ReactComponent as ImgBtnCloseWhite } from '../../../img/btn-close-white.svg'
import { useTranslation } from "react-i18next";
import { FONT } from "value/staticValues";



interface IBasicPopupModalProps {
  showPopupYn: boolean
  title?: String;
  desc: String;
  closeBtnCb: Function;
  // cancelBtn은 Function 이 아닌, boolean 으로 받아도 무방 함. (현재는 단순 취소 기능만 사용)
  // 하지만 추후 취소 버튼의 텍스트 또는 기능 변경 시를 대비하기 위해 Function으로 받음
  cancelBtnCb?: Function;
  cancelBtnText?: String;
  confirmBtnCb: Function;
  confirmBtnText: String;
}


export default function BasicPopupModal(props:IBasicPopupModalProps) {
  const { t } = useTranslation();

  return (
    <Modal transparent={true} visible={props.showPopupYn} animationType={'fade'}>
      <View style={style.mainContainer}>
        <div
          style={{
            width: 400,
            height: 222,
            boxShadow: 'rgba(216, 216, 216, 0.1',
            border: 'solid 1px #e6e6e6',
            borderRadius: 12,
            backgroundColor: '#ffffff',
          }}
        >

          {/* 닫기 버튼 */}
          <Pressable style={style.closeBtnStyle}
          onPress={() => {
            props.closeBtnCb();
          }}>
            <ImgBtnCloseWhite/>
          </Pressable>


          {/* title */}
          {
            (props.title)
            ?
              <View style={style.titleContainer}>
                <Text style={style.titleTextStyle}>
                  {props.title}
                </Text>
              </View>
            :
              <View style={{
                height: 20
              }}/>
          }


          {/* Description */}
          <View style={style.descContainer}>
            <Text style={style.descTextStyle}>
              {props.desc}
            </Text>
          </View>



          {/* Buttons */}
          <View style={style.buttonContainer}>

            {/* Cancel Button */}
            {
              (props.cancelBtnCb) &&
              <Pressable style={style.buttonCancelContainer}
              onPress={() => {
                (props.cancelBtnCb) && props.cancelBtnCb();
              }}>
                <Text style={style.buttonCancelTextStyle}>
                  {props.cancelBtnText}
                </Text>
              </Pressable>
            }


            {/* Confirm or Remove Button */}
            <Pressable style={style.buttonConfirmContainer}
            onPress={() => {
              props.confirmBtnCb();
            }}>
              <Text style={style.buttonConfirmTextStyle}>
                {props.confirmBtnText}
              </Text>
            </Pressable>
          </View>
        </div>
      </View>
    </Modal>
  )
}




const style = StyleSheet.create({
  mainContainer: {
    flex: 1,
    alignItems: 'center',
    height: '100vh',
    minWidth: 1920,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    paddingTop: 240
    // justifyContent: "center"
  },
  closeBtnStyle: {
    height: 50,
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 30
  },
  titleContainer: {
    width: "100%",
    height: 20,
    marginTop: 2,
    justifyContent: "center",
    alignItems: "center"
  },
  titleTextStyle: {
    flex: 1,
    fontSize: 15,
    lineHeight: 22,
    color: '#333333',
    fontFamily: FONT.MEDIUM
  },
  descContainer: {
    width: "100%",
    height: 44,
    marginTop: 8,
    justifyContent: "center",
    alignItems: "center",
  },
  descTextStyle: {
    fontSize: 14,
    lineHeight: 22,
    color: '#333333',
    fontFamily: FONT.REGULAR,
    textAlign: "center"
  },
  buttonContainer: {
    width: "100%",
    height: 98,
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingBottom: 30,
    paddingRight: 30,
    flexDirection: "row"
  },
  buttonCancelContainer: {
    width: 70,
    height: 36,
    borderRadius: 10,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: '#d4d9db',
    justifyContent: "center",
    alignItems: "center"
  },
  buttonCancelTextStyle: {
    fontSize: 12,
    lineHeight: 10,
    color: '#a6a6a6',
    fontFamily: FONT.MEDIUM,
  },
  buttonConfirmContainer: {
    width: 70,
    height: 36,
    borderRadius: 10,
    borderStyle: "solid",
    backgroundColor: '#4f5fd8',
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 10
  },
  buttonConfirmTextStyle: {
    fontSize: 12,
    lineHeight: 10,
    color: '#ffffff',
    fontFamily: FONT.MEDIUM,
  }
})